import { useQuery } from '@tanstack/react-query'
import { useParams } from '@tanstack/react-router'

import { clientPortalEoirInternalCaseInformationQuery } from '@/lib/queries/case-dashboard/v1/portal/eoir-cases/queries'
import { clientPortalRelevantCasesQuery } from '@/lib/queries/case-dashboard/v1/portal/relevant-case/queries'

export const useClientPortalEoirInternalData = () => {
  const { applicantId, caseId } = useParams({
    from: '/client-portal/eoir/internal/$applicantId/$caseId',
  })

  const { data: dataClientPortalEoirInternal } = useQuery(clientPortalEoirInternalCaseInformationQuery(Number(caseId)))
  const { data: dataAllApplicantCases } = useQuery(clientPortalRelevantCasesQuery(Number(caseId)))

  const caseNumber = dataClientPortalEoirInternal?.caseInformation.alienNumber
  const companyId = dataClientPortalEoirInternal?.company.companyId

  return {
    dataClientPortalEoirInternal,
    dataAllApplicantCases,
    applicantId,
    caseId: Number(caseId),
    caseNumber,
    companyId,
  }
}
